// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2G9Qv","label":"styles_label__2_qAh"};